require('intersection-observer')
// import 'babel/polyfill'
import 'polyfill-array-includes';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import mobileMixin from '@/mixins/mobileMixin'
import DeviceDetect from './mixins/DeviceDetect'
import ResponsiveCss from './mixins/ResponsiveCss'
import compareMixin from '@/mixins/compareMixin'

// import indData from '@/mixins/indData'
import RouterLinkedData from '@/plugins/RouterLinkedData'
import AsyncComputed from 'vue-async-computed'
import i18n from './i18n'
import VueScrollTo from 'vue-scrollto'
import VTooltip from 'v-tooltip'
import VueSocialSharing from 'vue-social-sharing'
import Clipboard from 'v-clipboard'
 
// matchall polyfill...
import shim from 'string.prototype.matchall/shim'
shim()
// Vue.mixin(mobileMixin)

Vue.mixin(DeviceDetect)
// Vue.mixin(indData)
Vue.use(RouterLinkedData)
Vue.use(AsyncComputed)
Vue.mixin(i18n)
Vue.use(VueScrollTo)
Vue.use(VTooltip)
Vue.use(VueSocialSharing)
Vue.mixin(compareMixin)
Vue.use(Clipboard)

IntersectionObserver.prototype.POLL_INTERVAL = 100
Vue.config.productionTip = false




new Vue({
  router,
  store,
  render: h => h(App),
  mixins: [ResponsiveCss]
}).$mount('#app')
